import React from "react";

function IconSchools(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 15v-3.71a.9.9 0 1 1 1.8 0V15a.9.9 0 1 1-1.8 0Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 15a.9.9 0 0 1 .9-.9v.9c0-.9 0-.9.002-.9h.027a.882.882 0 0 1 .1.008c.05.005.11.014.179.028.138.028.324.076.577.16.503.168 1.294.487 2.517 1.099a21.998 21.998 0 0 1 2.816 1.664 14.016 14.016 0 0 1 .911.698l.053.045.015.014.005.005.002.001v.001L12 18.49l.605-.667a.9.9 0 0 1-1.21 1.334l-.005-.005-.032-.028a12.226 12.226 0 0 0-.776-.593 20.207 20.207 0 0 0-2.584-1.526c-1.177-.588-1.886-.869-2.283-1.001a3.169 3.169 0 0 0-.379-.106A.9.9 0 0 1 4.5 15Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 15a.9.9 0 0 0-.9-.9v.9c0-.9 0-.9-.002-.9h-.027a.888.888 0 0 0-.1.008c-.05.005-.11.014-.179.028a4.896 4.896 0 0 0-.577.16c-.503.168-1.294.487-2.518 1.099a21.999 21.999 0 0 0-2.815 1.664 14.016 14.016 0 0 0-.911.698l-.053.045-.015.014-.005.005-.002.001v.001l.604.667-.605-.667a.9.9 0 0 0 1.21 1.334c-.001 0 0 0 0 0l.005-.005.032-.028a12.226 12.226 0 0 1 .776-.593 20.203 20.203 0 0 1 2.585-1.526c1.176-.588 1.885-.869 2.282-1.001a3.167 3.167 0 0 1 .379-.106A.9.9 0 0 0 19.5 15Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7 14.89v-3.6a.9.9 0 1 1 1.8 0v3.6a.9.9 0 0 1-1.8 0Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 9.608a.9.9 0 0 1-.498.797l-9.381 4.69a.9.9 0 0 1-.79.007l-9.819-4.69a.9.9 0 0 1-.015-1.617l9.819-4.91a.9.9 0 0 1 .82.007l9.381 4.91a.9.9 0 0 1 .483.806ZM12.209 5.701l-7.76 3.88 7.76 3.707 7.415-3.706L12.209 5.7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 9.6v7.2h-1.8V9.6h1.8Z"
        fill="currentColor"
      />
      <path
        d="M22.8 16.8a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconSchools;
